import { createContext } from 'react';
import { FLYOUT_TITLE_ID } from "./constants";
export var FlyoutContext = /*#__PURE__*/createContext({
  flyoutTitleId: FLYOUT_TITLE_ID
});
FlyoutContext.displayName = 'FlyoutContext';